import { useAuth0 } from '@auth0/auth0-react';
import { CircularProgress } from '@material-ui/core';
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import DeleteSvgComponent from "assets/icons/svg/DeleteSvg/Delete";
import { Loader, MyCheckbox } from 'components';
import AddAchCard from 'components/addAchCard/AddAchCard';
import Button from 'components/button/Button';
import AlertDialog from "components/Dialog";
import MyModal from "components/MyModal";
import VerifyAchCardInfo from 'components/verifyAchCardInfo/VerifyAchCardInfo';
import FinanceService from 'Lib/API/Finance';
import React, { useEffect, useMemo, useState } from 'react';
import { toastr } from "react-redux-toastr";
import { CreditCardMethodButton, CreditCardMethodContainer, CreditCardMethodContent, CreditCardMethodHeader, CreditCardMethodItem, CreditCardMethodItemVerify, CreditCardMethodItemVerifyInput, CreditCardMethodList, CreditCardMethodTitle } from './Theme';
const AchMethod = ({

}) => {
  const accountId = localStorage.getItem("accountID");

  const { getAccessTokenSilently } = useAuth0();

  const [cardList, setCardList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [creditId, setCreditId] = useState(null);
  const [openAlert, setOpenAlert] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [defaultCard, setDefaultCard] = useState(null);
  const [setDefaultLoading, setSetDefaultLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [openVerifyModal, setOpenVerifyModal] = useState(false);
  const [verifyData, setVerifyData] = useState({
    achNumberOne: "",
    achNumberTwo: "",
  });
  const [verifyLoading, setVerifyLoading] = useState(false);


  const getAchCards = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    await FinanceService.getACHCardsByAccountId(token, accountId)
      .then((res) => {
        setCardList(res?.ach?.data || []);
        const findDefaultCard = res?.ach?.data?.find((card) => card?.is_default);
        if (findDefaultCard) {
          setDefaultCard(findDefaultCard?.id); 
        } else if (res?.ach?.data?.length === 1) {
          handleDefaultCardChange(res?.ach?.data[0]?.id);
        }
      })
      .catch((err) => {
        toastr.error('Error', err?.data?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const handleSetDefaultCard = async (cardId) => {
    const token = await getAccessTokenSilently();
    const data = {
      accountId,
      achId: cardId,
    };
    setSetDefaultLoading(true);
    await FinanceService.setDefaultAch(data, token)
      .then((res) => {
        toastr.success("Success", "Default card set successfully");

      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        const timeOut = setTimeout(() => {
          setSetDefaultLoading(false);
        }, 2000);
        return () => {
          clearTimeout(timeOut);
        };
      });

  };

  const handleDelete = async (cardID) => {
    setDeleteLoading(true);
    const token = await getAccessTokenSilently();
    await FinanceService.deleteAchCard(
      token,
      cardID,
      accountId
    )
      .then(() => {
        toastr.success("Success", "ACH Deleted Successfully");
        getAchCards();
        closeConfirmDialog();
      })
      .catch((error) => {
        toastr.error('Error', error?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setDeleteLoading(false);
      });
  };

  const handleVerifyAch = async (item) => {
    setVerifyLoading(true);
    const data = {
      accountId,
      achId: item?.id,
      firstAmount: verifyData?.achNumberOne,
      secondAmount: verifyData?.achNumberTwo,
    };
    const token = await getAccessTokenSilently();
    FinanceService.verifyAch(data, token)
      .then(() => {
        getAchCards();
        toastr.success("Success", "ACH account verified successfully");
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.data?.message ?? "Please enter valid details"
        );
      })
      .finally(() => {
        setVerifyLoading(false);
      });
  };

  useEffect(() => {
    getAchCards();
  }, []);

  const onVerifyAchChange = (e) => {
    const { value, name } = e.target;
    setVerifyData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  }

  const handleDefaultCardChange = (cardId) => {
    setDefaultCard(cardId);
    handleSetDefaultCard(cardId)
  };

  const openConfirmDialog = (id) => {
    setCreditId(id);
    setOpenAlert(true);
  };

  const closeConfirmDialog = () => {
    setOpenAlert(false);
    setCreditId(null);
  };


  const openVerifyInfoModal = (cardId) => {
    setOpenVerifyModal(true);
  }

  const closeVerifyInfoModal = () => {
    setOpenVerifyModal(false);
  }


  const isVerifyBtnDisabled = useMemo(() => {
    return !verifyData?.achNumberOne || !verifyData?.achNumberTwo || verifyLoading;
  }, [verifyData, verifyLoading]);


  return (
    <>
      <CreditCardMethodContainer>
        <CreditCardMethodHeader>
          <CreditCardMethodTitle>ACH</CreditCardMethodTitle>
          <Button
            variant="primary"
            size="md"
            onClick={() => setOpenModal(true)}
            style={{
              minWidth: 165,
            }}
          >
            <PlusIcon />
            <span>Add New ACH</span>
          </Button>
        </CreditCardMethodHeader>
        <CreditCardMethodContent>

          {loading ? (
            <Loader />
          ) : cardList?.length > 0 ? cardList?.map((card) => (
            <CreditCardMethodList key={card?.id} className="credit-card">
              <CreditCardMethodItem>
                <p>
                  {`${card.nameOnAccount ? card.nameOnAccount : ""} ${card.accountNumber ? "/ " + card.accountNumber : ""
                    }`}
                  <CreditCardMethodButton
                    onClick={() => openConfirmDialog(card?.id)}
                  >
                    <DeleteSvgComponent
                      color={"gray"}
                    />
                  </CreditCardMethodButton>
                    <div
                      style={setDefaultLoading ? {
                        pointerEvents: "none",
                        opacity: 0.7
                      } : {}}
                    >
                      <MyCheckbox
                        title={"Set as default"}
                        handlechange={(e) => {
                          handleDefaultCardChange(card?.id);
                        }}
                        checked={defaultCard === card?.id}
                      />
                    </div>
                </p>
                {card?.status !== "verified" && (
                  <CreditCardMethodItemVerify>
                    <CreditCardMethodItemVerifyInput
                      type="text"
                      maxLength={2}
                      name="achNumberOne"
                      onChange={onVerifyAchChange}
                    />
                    <CreditCardMethodItemVerifyInput
                      type="text"
                      maxLength={2}
                      name="achNumberTwo"
                      onChange={onVerifyAchChange}
                    />
                    <Button
                      size="sm"
                      variant="primary"
                      onClick={() => handleVerifyAch(card)}
                      disabled={isVerifyBtnDisabled}
                      style={{
                        minWidth: 70,
                      }}
                    >
                      {verifyLoading ?
                        <CircularProgress color="#FFFFFF" size={16} />
                        : "Verify"}
                    </Button>
                  </CreditCardMethodItemVerify>
                )}
              </CreditCardMethodItem>
            </CreditCardMethodList>
          )) : (
            <h1 className="no-cards">NO ACH</h1>
          )}
        </CreditCardMethodContent>
      </CreditCardMethodContainer>
      <AlertDialog
        open={openAlert}
        handleClose={() => {
          closeConfirmDialog();
        }}
        onDecline={() => {
          setOpenAlert(false);
        }}
        onAccept={() => {
          handleDelete(creditId);
        }}
        content={"Are you sure you want to delete this ACH?"}
        contentStyle={{
          fontSize: "18px",
        }}
        disabled={deleteLoading}
      />
      <MyModal
        className="add-card-modal"
        open={openModal}
        onClose={() => setOpenModal(false)}
      >
        <AddAchCard
          setOpenModal={setOpenModal}
          refetchAchCards={getAchCards}
          closeModal={() => setOpenModal(false)}
          openVerifyInfoModal={openVerifyInfoModal}
        />
      </MyModal>
      <MyModal
        className="main__alert-dialog"
        open={openVerifyModal}
        onClose={closeVerifyInfoModal}
      >
        <VerifyAchCardInfo
          closeModal={closeVerifyInfoModal}
        />
      </MyModal>
    </>
  )
}

export default AchMethod